export const iconFontAwesomeArrowsArrowTrendDown = (
	<i className="fa-solid fa-arrow-trend-down"></i>
);
